import { Component, ViewEncapsulation, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { DayModalDataService } from '../day-modal-data.service';

import { ModalService } from './modal.service';

@Component({ 
    selector: 'jw-modal', 
    templateUrl: 'modal.component.html', 
    styleUrls: ['modal.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() id!: string;
    private element: any;
    // private el!: any;
    @Input() todayIs: number =777;
    
    //Modal variables
    message!: string;
    modalDate!: number;
    modalMonthName!: any;
    modalSignIcon!: any;
    firstQMoon!: boolean;
    firstQMoon2!: boolean;
    lastQMoon!: boolean;
    lastQMoon2!: boolean;
    newMoon!: boolean;
    newMoon2!: boolean;
    fullMoon!: boolean;
    fullMoon2!: boolean;
    todaySun!: boolean;

    constructor(private modalService: ModalService, private el: ElementRef, private dayModalDataService: DayModalDataService) {
        this.element = el.nativeElement;
    }

    ngOnInit(): void {

        this.dayModalDataService.currentMessage.subscribe(message => this.message = message);
        this.dayModalDataService.currentModalDate.subscribe(modalDate => this.modalDate = modalDate);
        this.dayModalDataService.currentModalMonth.subscribe(modalMonthName => this.modalMonthName = modalMonthName);
        this.dayModalDataService.currentModalSign.subscribe(modalSignIconName => this.modalSignIcon = modalSignIconName);
        this.dayModalDataService.currentFirstQMoon.subscribe(modalfirstQMoon => this.firstQMoon = modalfirstQMoon);
        this.dayModalDataService.currentFirstQMoon2.subscribe(modalfirstQMoon2 => this.firstQMoon2 = modalfirstQMoon2);
        this.dayModalDataService.currentLastQMoon2.subscribe(modalLastQMoon2 => this.lastQMoon2 = modalLastQMoon2);
        this.dayModalDataService.currentLastQMoon.subscribe(modalLastQMoon => this.lastQMoon = modalLastQMoon);
        this.dayModalDataService.currentFullMoon2.subscribe(fullMoon2 => this.fullMoon2 = fullMoon2);
        this.dayModalDataService.currentFullMoon.subscribe(fullMoon => this.fullMoon = fullMoon);
        this.dayModalDataService.currentNewMoon2.subscribe(newMoon2 => this.newMoon2 = newMoon2);
        this.dayModalDataService.currentNewMoon.subscribe(newMoon => this.newMoon = newMoon);
        this.dayModalDataService.currentTodaySun.subscribe(todaySun => this.todaySun = todaySun);

        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        this.element.addEventListener('click', (el:any) => {
            if (el.target.className === 'jw-modal') {
                this.close();
            }
        });

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when component is destroyed
    ngOnDestroy(): void {
        this.modalService.remove(this.id);
        this.element.remove();
    }

    // open modal
    open(): void {
        this.element.style.display = 'block';
        console.log('double check', this.id)
        // document.body.classList.add('jw-modal-open');
        document.body.classList.add('nav-modal-open');

    }

    // close modal
    close(): void {
        this.element.style.display = 'none';
        // document.body.classList.remove('jw-modal-open');
        document.body.classList.remove('nav-modal-open');
    }

}